import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminSubscriptionOrderTypeProviderService } from '../providers/admin-subscription-order-type-provider.service';
import { AdminSubscriptionOrderType } from '../enums/admin-subscription-order-type';

@Pipe({
  name: 'adminSubscriptionOrderType',
})
export class AdminSubscriptionOrderTypePipe implements PipeTransform {
  private readonly provider = inject(AdminSubscriptionOrderTypeProviderService);

  public transform(status: AdminSubscriptionOrderType): Observable<string> {
    return this.provider.labelFor(status);
  }
}
